import React from 'react';
import { T as Typography } from './Typography-BUVIUAC9.js';
import { B as Button } from './Button-DJQVVE0-.js';

var styles = {"header":"Q-mwo-g5Fi8-"};

function ComboboxContentHeader(props) {
    const hasSelected = props.selectedCount > 0;
    const actionLabel = hasSelected ? "Clear" : "Select all";
    const label = getLabel(hasSelected, props.selectedCount, props.subjectNoun);
    const handleSelectAll = hasSelected ? props.onClearAll : props.onSelectAll;
    const showAction = hasSelected || props.hasOptionsVisible;
    return (React.createElement("div", { className: styles.header, "data-testid": "ATL-Combobox-Header" },
        React.createElement(Typography, { textColor: "heading", fontWeight: "semiBold" }, label),
        showAction && (React.createElement(Button, { size: "small", label: actionLabel, type: "tertiary", onClick: handleSelectAll }))));
}
function getLabel(hasSelected, count, subjectNoun) {
    if (hasSelected) {
        return `${count} selected`;
    }
    if (subjectNoun) {
        return `Select ${subjectNoun}`;
    }
    return "Select";
}

export { ComboboxContentHeader as C };
